// frontend/src/components/account/MembershipPanel.jsx
import { Button, Typography, Space } from "antd";

const { Text } = Typography;

const formatDate = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

const MembershipPanel = ({
  profile,
  isCancelSubscriptionLoading,
  isResumeSubscriptionLoading,
  isResubscribeLoading,
  handleCancelSubscription,
  handleResumeSubscription,
  handleResubscribe,
}) => {
  const status = (profile?.subscriptionStatus || "").toLowerCase();
  const cancelAtPeriodEnd = !!profile?.subscriptionCancelAtPeriodEnd;
  const periodEndLabel = formatDate(profile?.subscriptionCurrentPeriodEnd);

  const isActive = status === "active" || status === "trial" || status === "trialing";
  const isScheduledCancel = isActive && cancelAtPeriodEnd;
  const needsResubscribe =
    ["cancelled", "canceled", "past_due", "unpaid", "incomplete_expired"].includes(
      status
    );

  return (
    <div style={{ padding: "16px 0" }}>
      {isScheduledCancel ? (
        <Text style={{ display: "block", marginBottom: "16px", color: "#666" }}>
          Your subscription is set to cancel
          {periodEndLabel ? (
            <>
              {" "}
              on <strong>{periodEndLabel}</strong>
            </>
          ) : null}
          . You keep access until then. Choose <strong>Keep plan</strong> to
          undo cancellation (no new charge).
        </Text>
      ) : needsResubscribe ? (
        <Text style={{ display: "block", marginBottom: "16px", color: "#666" }}>
          {["past_due", "unpaid"].includes(status) ? (
            <>
              Your last renewal payment failed. Try{" "}
              <strong>Update payment method</strong> first to pay on this same
              plan. Only use Resubscribe if that does not work — Resubscribe
              starts a new subscription.
            </>
          ) : (
            <>
              Your subscription is inactive. Resubscribe to restore access to
              SFBB Pro.
            </>
          )}
        </Text>
      ) : (
        <Text style={{ display: "block", marginBottom: "16px", color: "#666" }}>
          You are currently on a Monthly Plan. Cancel anytime — you keep access
          until the end of the current billing period.
        </Text>
      )}

      <Space wrap>
        {isActive && !cancelAtPeriodEnd && (
          <Button
            type="primary"
            danger
            loading={isCancelSubscriptionLoading}
            onClick={handleCancelSubscription}
            style={{ borderRadius: "6px" }}
          >
            Cancel Subscription
          </Button>
        )}

        {isScheduledCancel && (
          <Button
            type="primary"
            loading={isResumeSubscriptionLoading}
            onClick={handleResumeSubscription}
            style={{
              borderRadius: "6px",
              backgroundColor: "#6DB33F",
              borderColor: "#6DB33F",
            }}
          >
            Keep plan / Resubscribe
          </Button>
        )}

        {needsResubscribe && (
          <Button
            type="primary"
            loading={isResubscribeLoading}
            onClick={handleResubscribe}
            style={{
              borderRadius: "6px",
              backgroundColor: "#6DB33F",
              borderColor: "#6DB33F",
            }}
          >
            Resubscribe
          </Button>
        )}
      </Space>
    </div>
  );
};

export default MembershipPanel;
